import React from "react";

import Icons from "@/assets/icons";
import { IconProps } from "./Icon.types";

function Icon({ name, ...props }: IconProps) {
  const IconComponent = Icons[name];
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <IconComponent {...props} />;
}

export default Icon;
